import "@/App.css";
import { useLayoutEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import IdaWidget from "@/components/IdaWidget";
import Landing from "@/pages/Landing";
import Blueprint from "@/pages/Blueprint";
import HowItWorks from "@/pages/HowItWorks";
import Services from "@/pages/Services";
import Connect from "@/pages/Connect";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import AuthCallback from "@/pages/AuthCallback";
import Journal from "@/pages/Journal";
import Article from "@/pages/Article";
import JournalAdmin from "@/pages/JournalAdmin";
import CreateWithUs from "@/pages/CreateWithUs";
import SelectedWork from "@/pages/SelectedWork";
import HQEnquiries from "@/pages/hq/HQEnquiries";
import HQProject from "@/pages/hq/HQProject";
import HQTrends from "@/pages/hq/HQTrends";

function AppRouter() {
  const location = useLocation();

  // Every page opens like a fresh chapter: always from the very top,
  // before paint, with no animated scroll fighting the transition.
  useLayoutEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [location.pathname]);

  // Detect session_id during render (NOT in useEffect) to avoid the race.
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/discovery" element={<Navigate to="/" replace />} />
      <Route path="/blueprint/:id" element={<Blueprint />} />
      <Route path="/how-it-works" element={<HowItWorks />} />
      <Route path="/services" element={<Services />} />
      <Route path="/connect" element={<Connect />} />
      <Route path="/projects" element={<Projects />} />
      <Route path="/projects/:id" element={<ProjectDetail />} />
      <Route path="/hq" element={<HQEnquiries />} />
      <Route path="/hq/trends" element={<HQTrends />} />
      <Route path="/hq/projects/:id" element={<HQProject />} />
      <Route path="/journal" element={<Journal />} />
      <Route path="/insights" element={<Navigate to="/journal" replace />} />
      <Route path="/selected-work" element={<SelectedWork />} />
      <Route path="/journal/admin" element={<JournalAdmin />} />
      <Route path="/journal/:slug" element={<Article />} />
      <Route path="/create-with-us" element={<CreateWithUs />} />
      <Route path="/careers" element={<Navigate to="/create-with-us" replace />} />
      <Route path="/contact" element={<Navigate to="/connect" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <IdaWidget />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
